import React, { useEffect, useState } from "react";
import {
    withGoogleMap,
    withScriptjs,
    GoogleMap,
    // Marker,
} from "react-google-maps";
import Marker from "./Marker";
const { InfoBox } = require("react-google-maps/lib/components/addons/InfoBox");

const Map = withScriptjs(
    withGoogleMap((props) => {
        const [activeMarker, setActiveMarker] = useState(null);

        return (
            <GoogleMap
                style={{
                    borderRadius: "15px",
                }}
                defaultZoom={props.defaultZoom}
                defaultCenter={props.position}
                onClick={() => {
                    // console.log("hello");
                    setActiveMarker(null);
                }}
            >
                {props.clinics.map((clinic) => clinic.latitude != null && clinic.longitude != null && (
                    // On switch back to use ID when query from DB
                    // <Marker
                    //     key={clinic.id}
                    //     onMarkerClick={() => setActiveMarker(clinic.id)}
                    //     onInfoBoxClose={() => setActiveMarker(null)}
                    //     displayInfoBox={activeMarker == clinic.id}
                    //     position={{
                    //         lat: parseFloat(clinic.latitude),
                    //         lng: parseFloat(clinic.longitude),
                    //     }}
                    //     clinic={clinic}
                    // />
                    <Marker
                        key={clinic.code}
                        onMarkerClick={() => setActiveMarker(clinic.code)}
                        onInfoBoxClose={() => setActiveMarker(null)}
                        displayInfoBox={activeMarker == clinic.code}
                        position={{
                            lat: parseFloat(clinic.latitude),
                            lng: parseFloat(clinic.longitude),
                        }}
                        clinic={clinic}
                    />
                ))}
            </GoogleMap>
        );
    })
);

export default Map;
